import { render } from "./Privacy.vue?vue&type=template&id=d521de3e"
const script = {}

import exportComponent from "D:\\Project\\skin-web\\碎梦者\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__